import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { track } from "@/lib/track";

/**
 * Lands here after Google OAuth: /auth/callback#session_id=...
 * Exchanges the session_id with the backend, then redirects home.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const m = (location.hash || "").match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      const res = await loginWithGoogleSession(sessionId);
      // Clear hash either way to prevent re-exchange.
      try { window.history.replaceState({}, "", "/auth/callback"); } catch {}
      if (res?.ok) {
        track("login_complete", { from: "google" }, { once: false });
        navigate("/me", { replace: true });
      } else {
        navigate("/?auth=error", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div dir="rtl" className="min-h-screen bg-[#182138] text-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 text-[#18c98f] mx-auto animate-spin mb-3" />
        <p className="text-sm text-white/70">جارٍ إكمال تسجيل الدخول...</p>
      </div>
    </div>
  );
}
